<template>
  <div>
    <modal-edit-text
      v-if="showEditText"
      :showModal="showEditText"
      :onClickCancel="hideModal"
      :locationId="locationId"
    />

    <ui-section-header
      :showEdit="true"
      :editFunction="setShowEditText"
      :editLabel="'Edit'"
    >
      <template v-slot:title>Publication texts</template>
    </ui-section-header>

    <div class="columns">
      <div
        v-for="(textLanguage, index) in option.Texts"
        :key="index"
        class="column"
      >
        <div class="title is-5">
          {{ $t('LanguageLabels.Language' + textLanguage.LanguageId) }}
        </div>

        <div class="textWrapper">
          <strong>Name:</strong><br />
          {{ textLanguage.Name }}

          <div class="is-divider"></div>

          <strong>Description:</strong><br />
          <div
            class="content"
            v-html="textLanguage.Description"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const ModalEditText = () => import('@/components/Options/ModalEditOptionText')

export default {
  components: {
    'modal-edit-text': ModalEditText,
  },

  props: {},

  data() {
    return {
      locationId: this.$route.params.locationId
        ? Number(this.$route.params.locationId)
        : 0,
      showEditText: false,
    }
  },

  computed: {
    ...mapState('optionStore', ['option']),
  },

  created() { },

  methods: {
    setShowEditText() {
      this.showEditText = true
    },

    hideModal() {
      this.showEditText = false
    },
  },
}
</script>
